/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-continue */
import IconAngleBottom from '@assets/icons/angle-bottom.svg?react';
import IconAngleTop from '@assets/icons/angle-top.svg?react';
import IconMeter from '@assets/icons/meter.svg?react';
import IconMoon from '@assets/icons/moon.svg?react';
import IconNav from '@assets/icons/nav.svg?react';
import IconSearch from '@assets/icons/search.svg?react';
import IconSun from '@assets/icons/sun.svg?react';
import {
 AppBar,
 Avatar,
 Box,
 Button,
 IconButton,
 Menu,
 MenuItem,
 TextField,
 Theme,
 Toolbar,
 useColorScheme,
 useTheme,
} from '@mui/material';
import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { identityLogoutStart } from '../../redux/identity/identitySlice';
import layoutSizes from '../../utils/layoutSizes';
import UserProfileModal from './UserProfileModal';

const Search = () => {
 const { t } = useTranslation();
 const theme = useTheme();
 return (
  <Box
   sx={{
    position: 'relative',
    display: { xs: 'none', md: 'block' },
   }}
  >
   <TextField size="small" placeholder={t('global.search')} />
   <Box
    sx={{
     position: 'absolute',
     top: '50%',
     right: '8px',
     pointerEvents: 'none',
     transform: 'translateY(-50%)',
     background: theme.palette.kemek.bg2,
     width: '24px',
     height: '24px',
     display: 'inline-flex',
     alignItems: 'center',
     justifyContent: 'center',
    }}
   >
    <IconSearch
     style={{
      color: theme.palette.kemek.lightGray,
      display: 'block',
      width: '13.516px',
      height: '13.516px',
     }}
    />
   </Box>
  </Box>
 );
};

const ScalesWidget = () => (
 <Box
  sx={{
   display: 'flex',
   alignItems: 'center',
   ml: 'auto',
   gap: 1,
   p: 1,
   borderRadius: '16px',
   lineHeight: '18px',
   border: (theme: Theme) => `1px solid ${theme.palette.kemek.lightGray}`,
   fontWeight: 500,
   height: 32,
   pr: '4px',
  }}
 >
  <Box
   sx={{
    color: (theme: Theme) => theme.palette.kemek.lightGray,
    fontSize: 12,
   }}
  >
   Svarstyklės 1
  </Box>
  <Box
   sx={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: (theme: Theme) => theme.palette.kemek.white,
    background: (theme: Theme) => theme.palette.kemek.lightGray,
    textAlign: 'center',
    width: '24px',
    height: '24px',
    borderRadius: '24px',
    lineHeight: '24px',
    fontSize: 16,
    fontWeight: 500,
   }}
  >
   0
  </Box>
 </Box>
);

const UserWidget = () => {
 const { t, i18n } = useTranslation();
 const languages = i18n?.options?.resources;
 const dispatch = useDispatch();
 const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
 const [profileModalOpen, setProfileModalOpen] = useState(false);
 const open = Boolean(anchorEl);

 const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
  setAnchorEl(event.currentTarget);
 };
 const handleClose = () => {
  setAnchorEl(null);
 };

 const handleAvatarClick = () => {
  setProfileModalOpen(true);
 };

 const handleProfileModalClose = () => {
  setProfileModalOpen(false);
 };

 const user = {
  name: 'demo@kemek.lt',
  avatar: new URL('@assets/user.jpg', import.meta.url).href,
 };

 return (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', order: 3 }}>
   <IconButton onClick={handleAvatarClick}>
    <Avatar alt="Remy Sharp" src={user.avatar} sx={{ cursor: 'pointer' }} />
   </IconButton>
   <Button
    id="user-menu-button"
    aria-controls={open ? 'user-menu-menu' : undefined}
    aria-haspopup="true"
    aria-expanded={open ? 'true' : undefined}
    onClick={handleClick}
    variant="text"
    sx={(theme: Theme) => ({
     fontSize: 12,
     color: theme.palette.kemek.darkestGray,
     fontWeight: 'medium',
     px: 1,
     display: { xs: 'none', md: 'flex' },
    })}
    endIcon={open ? <IconAngleTop /> : <IconAngleBottom />}
   >
    {user.name}
   </Button>
   <Menu
    id="user-menu-menu"
    anchorEl={anchorEl}
    open={open}
    onClose={handleClose}
    MenuListProps={{
     disablePadding: true,
     'aria-labelledby': 'user-menu-button',
    }}
   >
    {((languages && Object.keys(languages)) || [])?.map((lng) => (
     <MenuItem
      color={i18n.language === lng ? 'primary' : 'inherit'}
      key={lng}
      sx={{
       color: (theme: Theme) =>
        i18n.language === lng ? theme.palette.kemek.blue : 'inherit',
       pointerEvents: i18n.language === lng ? 'none' : 'auto',
      }}
      onClick={() => {
       i18n.changeLanguage(lng);
       //    alert('fix ls rewrite here');
       localStorage.removeItem('structure');
       handleClose();
       window.location.reload();
      }}
     >
      {lng.toUpperCase()}
     </MenuItem>
    ))}
    {/* <MenuItem onClick={handleClose}>Profile</MenuItem>
    <MenuItem onClick={handleClose}>My account</MenuItem> */}
    <MenuItem
     onClick={() => {
      dispatch(identityLogoutStart());
     }}
    >
     Logout
    </MenuItem>
   </Menu>
   <UserProfileModal
    open={profileModalOpen}
    onClose={handleProfileModalClose}
   />
  </Box>
 );
};

function Header({
 isSidebarOpen,
 setIsSidebarOpen,
}: {
 isSidebarOpen: boolean;
 setIsSidebarOpen: Dispatch<SetStateAction<boolean>>;
}) {
 const { mode, setMode } = useColorScheme();
 const theme = useTheme();

 return (
  <AppBar
   elevation={0}
   position="fixed"
   sx={{
    height: layoutSizes.headerHeight,
    width: isSidebarOpen
     ? { xs: '100%', md: `calc(100% - ${layoutSizes.sidebarWidth}px)` }
     : { xs: '100%', md: 'calc(100% - 76px)' },
    ml: isSidebarOpen
     ? { xs: '100%', md: `${layoutSizes.sidebarWidth}px` }
     : { xs: '0px', md: '76px' },
    boxShadow: 'none',
    background: theme.palette.kemek.bg2,
    borderBottom: `1px solid ${theme.palette.kemek.lightestGray}`,
   }}
  >
   <Toolbar sx={{ height: '100%' }}>
    <IconButton
     size="large"
     edge="start"
     color="inherit"
     aria-label="menu"
     sx={{ mr: 2, width: 44, height: 44 }}
     onClick={() => setIsSidebarOpen((prevState) => !prevState)}
    >
     <IconNav style={{ color: theme.palette.kemek.darkestGray }} />
    </IconButton>

    {/* <Search /> */}
    <Box
     sx={{
      gap: { xs: '24px', md: '32px' },
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
     }}
    >
     {/* <Box>localStorage: {lsSize()}</Box> */}
     <IconButton
      size="large"
      sx={{ p: '4px', height: 24, display: { xs: 'block', md: 'none' } }}
      edge="start"
      color="inherit"
      aria-label="menu"
     >
      <IconMeter />
     </IconButton>
     {/* <Box
      sx={{
       display: { xs: 'none', md: 'flex' },
       alignItems: 'center',
       gap: '20px',
      }}
     >
      <ScalesWidget />
      <ScalesWidget />
     </Box> */}
     <UserWidget />
     <IconButton
      onClick={() => setMode(mode === 'dark' ? 'light' : 'dark')}
      size="large"
      sx={{
       p: '0px',
       width: 24,
       height: 24,
       ml: 0,
       display: { xs: 'none', md: 'flex' },
      }}
      edge="start"
      color="inherit"
      aria-label="menu"
     >
      {mode === 'dark' ? (
       <IconMoon
        style={{
         color: theme.palette.kemek.darkestGray,
         width: 24,
         height: 24,
        }}
       />
      ) : (
       <IconSun
        style={{
         color: theme.palette.kemek.darkestGray,
         width: 24,
         height: 24,
        }}
       />
      )}
     </IconButton>
     {/* <IconButton
      size="large"
      sx={{ p: '0px', height: 24, ml: 0 }}
      edge="start"
      color="inherit"
      aria-label="menu"
     >
      <IconSettings />
     </IconButton> */}
    </Box>
   </Toolbar>
  </AppBar>
 );
}
export default Header;
